import { gql } from 'graphql-request'

export const Q_USER_INVOICES = gql`
  query UserInvoices {
    userInvoices {
      ... on InvoiceList {
        invoices {
          id
          number
          status
          amountDue
          amountPaid
          currency
          created
          periodStart
          periodEnd
          hostedInvoiceUrl
          invoicePdf
        }
      }
      ... on QueryFailure {
        errors {
          message
        }
      }
    }
  }
`

export const Q_USER_UPCOMING_INVOICE = gql`
  query UserUpcomingInvoice {
    userUpcomingInvoice {
      ... on UpcomingInvoice {
        amountDue
        currency
        periodStart
        periodEnd
        lineItems {
          description
          amount
        }
      }
      ... on QueryFailure {
        errors {
          message
        }
      }
    }
  }
`
